module.exports = __webpack_public_path__ + "img/cat3.710fa81.png";